import { Component, OnInit, inject, input } from '@angular/core';
import { RelatedContentForFullAssetPage } from '../../../shared/interfaces/research-portal/full-asset-page/related-content-for-full-asset-page.interface';
import { FullAssetPage } from '../../../shared/configurations/full-asset-page.constant';
import { I18nService } from '../../../core/i18n.service';
import { TranslateModule } from '@ngx-translate/core';
import { SvgViewboxDirective } from '@exl-ng/mulo-core';
import { MatIcon } from '@angular/material/icon';
import { CitationBriefComponent } from '../../../parts/citations/citation-brief/citation-brief.component';

import { HorizontallerComponent, HorizontallerItemComponent } from '@exl-ng/mulo-common';

@Component({
    selector: 'esp-related-content',
    templateUrl: './related-content.component.html',
    styleUrls: ['./related-content.component.scss'],
    imports: [
        HorizontallerComponent,
        HorizontallerItemComponent,
        CitationBriefComponent,
        MatIcon,
        SvgViewboxDirective,
        TranslateModule
    ]
})
export class RelatedContentComponent implements OnInit {
    i18nService = inject(I18nService);

    readonly relations = input<RelatedContentForFullAssetPage[]>(undefined);
    readonly resourceType = input<string>(undefined);

    ngOnInit(): void {}

    limitTitle(title: string) {
        const max = FullAssetPage.MAX_TITLE_LENGTH;
        return title.length > max ? `${title.substr(0, max)}...` : title;
    }

    getRelationTitleURL(relation: RelatedContentForFullAssetPage) {
        return relation.relatedAssetURL;
    }
}
